import Fetch from "../../components/fetch";

export default class Books {
	constructor() {
		this.api = new Fetch;
	}

	async getBooks() {
		return await this.api.send('books');
	}

	async getBook(book) {
		return await this.api.send(`books/${book}`);
	}
}
